"use client";
import { createContext } from "../../utils/create-context.js";
//#region src/providers/environment/use-environment-context.ts
var [EnvironmentContextProvider, useEnvironmentContext] = createContext({
	name: "EnvironmentContext",
	hookName: "useEnvironmentContext",
	providerName: "<EnvironmentProvider />",
	strict: false,
	defaultValue: {
		getRootNode: () => document,
		getDocument: () => document,
		getWindow: () => window
	}
});
//#endregion
export { EnvironmentContextProvider, useEnvironmentContext };
